<template>
  <footer class="app-footer">
    <span><a href="http://www.sage9.com/">Sage9 Pte Ltd</a> &copy; 2018</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue